import { PropsWithChildren } from 'react';

export function Page({ children }: PropsWithChildren) {
  return children;
}
